import { meQueryOptions } from "@/api/auth";
import { myLocationQueryOptions } from "@/api/me";
import { queryClient } from "@/api/utils";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { TopNavigation, TopNavigationBackButton } from "@/components/ui/TopNavigation";
import { Box, Text } from "@givenwell/components";
import { fonts } from "@givenwell/theme";
import { createFileRoute, Outlet, useCanGoBack, useNavigate, useRouter } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/settings")({
  loader: () => {
    queryClient.prefetchQuery(meQueryOptions);
    queryClient.prefetchQuery(myLocationQueryOptions);
  },
  component: Settings,
});

function Settings() {
  const canGoBack = useCanGoBack();
  const router = useRouter();
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Box
        css={{
          width: "100%",
          maxWidth: 500,
          mx: "auto",
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box css={{ "@lg": { display: "none" }, pb: 16 }}>
          <TopNavigation
            title="Settings"
            left={
              <TopNavigationBackButton
                onClick={() => {
                  if (canGoBack) {
                    router.history.back();
                  } else {
                    navigate({ to: "/marketplace", replace: true });
                  }
                }}
              />
            }
          />
        </Box>
        <Box css={{ px: 16, display: "none", "@lg": { display: "flex" }, minH: 52, items: "center" }}>
          <Text css={{ fontScale: "xl", fontFamily: fonts.ftHabit }}>Settings</Text>
        </Box>
        <Box css={{ flex: "1 0 0px", overflowY: "auto", pb: 16 }}>
          <Outlet />
        </Box>
      </Box>
    </PageWrapper>
  );
}
